import React from 'react';
import { useSelector } from 'react-redux';
import { ArrowForward } from '@yme/assets/icons';
import { CONTAINED_VARIANT, SIZE_44, TRAILING_ICON } from '@yme/atoms/button';
import { Container, Row } from '@yme/atoms/grid';
import { IndentWrapper } from '@yme/components/Separator';
import { ButtonAnchor, ButtonLink } from '@yme/molecules/buttons';
import { getRTL } from '@yme/selectors/common';
import { isPDFlink } from '@yme/utils/common';
import { reqExpHasMailTo, reqExpHasTel } from '@yme/utils/regEx';
import { DATA_TEST_ID } from './constants';
import { ButtonCol } from './styled';
export function Button(props) {
    const { text, link, isRemoveBottomIndent, buttonAlign } = props;
    const isRightToLeft = useSelector(getRTL);
    const isTelLink = reqExpHasTel.test(link ?? '');
    const isMailLink = reqExpHasMailTo.test(link ?? '');
    const isPdfLink = isPDFlink(link ?? '');
    const buttonProperties = {
        buttonWidth: 'auto',
        buttonVariant: CONTAINED_VARIANT,
        hasIconButton: TRAILING_ICON,
        iconComponent: ArrowForward,
        isRightToLeft,
        size: SIZE_44,
        buttonLabel: text,
        buttonTitle: text,
        buttonLink: link ?? '',
    };
    const isAnchor = isMailLink || isTelLink || isPdfLink;
    if (text && link) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(Container, { dataTestId: DATA_TEST_ID },
                React.createElement(Row, { justifyContent: buttonAlign },
                    React.createElement(ButtonCol, null, isAnchor ? (React.createElement(ButtonAnchor, { ...buttonProperties })) : (React.createElement(ButtonLink, { ...buttonProperties })))))));
    }
    return null;
}
Button.displayName = 'Button_AEMComponent';
